<template>
   <div class="topContainer">
      <div class="pageHeader">Community Events</div>
      <div class="sectionInfo">
       
       <div class="sectionContent">
         <div class="redBoldText">Stay tuned for 2022 Events!</div>
         <div class="paddedSection">MOCI encourages our community partners to remember our motto, <span class="boldText">"Better Together"</span>.</div>
         <div class="definedSection">During this season, we hope that you choose to display kindness, consideration, sensitivity, and charity towards your neighbors.</div> 
         <div class="definedSection">As a result of this approach, this time in history will be remembered as a time when communities displayed the true source of humanity; love.  MOCI acknowledges the excellent experience of partnering with you and look forward to strengthening this partnership in the near future.</div>
       </div>
     </div>
      <div class="sectionInfo">
       <div class="sectionHeader">
         Past Events 
       </div>
       <div class="sectionContent">
         <div><button class='buttonStyle'><b-link to="/eventpics" :active="($route.path === '/eventpics')">View Pictures from Past Family Reunions</b-link></button></div>
       </div>
     </div>     
       <div class="sectionInfo" v-for="pastEvent in pastEvents" :key="pastEvent.title">
          <div><span class="inlineCBold">{{pastEvent.title}}</span> <span class='inlineCItalic'>{{pastEvent.date}}</span></div>
          <div class="inlineC">{{pastEvent.desc}}</div>
       </div>
   </div>
</template>
<script>
import {PastEvents} from '../pastEvents.js';
export default {
  data: function () {
     return { 
       pastEvents : PastEvents
     }
  }
}
</script>
<style scoped>
.topContainer{
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~@/assets/pastReunions.jpg') no-repeat center center fixed;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
     background-size: cover;
    height: 60px;
    width: 100%;
    position: relative;
    z-index: 2;
    border-bottom: 2px solid black;
    box-shadow: 1px 1px #111;
}
.imgSize {
   height: 200px;
   margin: 5px 5px;
}
.definedSection {
  margin-top:10px;
  border:1px solid #ccc; 
  border-radius: 4px;
  padding: 7px;
  color: #fff;
  letter-spacing: 1.5px;
  background-color: #a52411
}
.sectionContent{
  margin-top:0px;
}
.sectionHeader{
  margin: 4px;
}
.paddedSection{
  padding:10px;
}
</style>
